__turbopack_context__.v({
  "__container": "pay-with-stripe-step-module-scss-module__XW4F3W____container",
  "pay-with-stripe-step": "pay-with-stripe-step-module-scss-module__XW4F3W__pay-with-stripe-step",
});
